// extracted by mini-css-extract-plugin
export default {"item":"Item_item__0sJxy","preview":"Item_preview__4U7+U","number":"Item_number__gRebv","title":"Item_title__+HwGp","time":"Item_time__mqMWe"};